module.exports = __webpack_public_path__ + "Flag-585.0b7d9e32f60a3ffbf3900b80377c6fd6.svg";